<template>
  <v-progress-circular
    v-if="mode === 'circular'"
    :value="value"
    :color="color"
    :size="size"
    :width="width"
    :data-qa="dataQa"
    indeterminate />
  <v-progress-linear
    v-else-if="mode === 'linear'"
    active
    :color="color"
    :data-qa="dataQa"
    indeterminate />
</template>

<script>
export default {
  name: 'VcLoader',
  props: {
    value: {
      type: Number,
      default: 40,
    },
    mode: {
      type: String,
      default: 'circular',
      validator: function (value) {
        return ['circular', 'linear'].includes(value);
      },
    },
    color: {
      type: String,
      default: 'primary',
    },
    /**
     * Circumference of the loader in pixels
     */
    size: {
      type: Number,
      required: false,
    },
    /**
     * Line width in pixels
     */
    width: {
      type: Number,
      required: false,
    },
    dataQa: {
      type: String,
      default: 'VcLoader',
    },
  },
};
</script>
